import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./app/theme";
import Router from "./app/Router";
import Footer from "./NavBar/Footer";
import CookieConsent from "./pages/subPages/CookieConsent";
import { useEffect, useState } from "react";
import Loader from "./misc/Loader";

export default function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const disableContextMenu = (e) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", disableContextMenu);

    return () => {
      document.removeEventListener("contextmenu", disableContextMenu);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader isLoading={loading} />;

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Router />
        <CookieConsent />

        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
}
